import type { ReactNode } from "react";

export interface DescriptionListProps {
  readonly items: readonly {
    readonly key: string;
    readonly label: string;
    readonly value: ReactNode;
  }[];
}

export function DescriptionList({ items }: DescriptionListProps): ReactNode {
  return (
    <dl className="grid gap-4 sm:grid-cols-2">
      {items.map((item) => (
        <div key={item.key} className="min-w-0">
          <dt className="text-xs text-muted-foreground">{item.label}</dt>
          <dd className="mt-1 break-words text-sm font-medium">
            {item.value === null ||
            item.value === undefined ||
            item.value === ""
              ? "—"
              : item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
